import axios from "axios";
import { useQuery } from "react-query";
import { API_ENDPOINT } from "../../../../constants/constants";
import { getHeader } from "../../../../utility/utility";

const useGetFormEdit = () => {
  return useQuery({
    queryKey: ["get-my-profile-form"],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}/event/get-my-profile-form`,
        getHeader()
      );
      return response.data;
    },
    retry: (failureCount, error) => {
      if (!error.response) return failureCount < 2;
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500; // No retries for 404/500
    },
  });
};

export default useGetFormEdit;
